export default __webpack_public_path__ + "81f014865c5800e76454558fb67baba2.gif";